// GENERATED CODE - DO NOT MODIFY BY HAND

import * as m from '@april9au/stack9-sdk';
import { z } from 'zod';

export const OrganisationGroup = z.object({
  name: m.ZTextField,
  object_id: m.ZTextField,
});
export type OrganisationGroup = z.infer<typeof OrganisationGroup>;

export const DBOrganisationGroup = m.ZEntityInterface.merge(OrganisationGroup);
export type DBOrganisationGroup = z.infer<typeof DBOrganisationGroup>;
